module.exports = __webpack_public_path__ + "media/images/front/sp/institution-treatment-information/img_doctor03-202b2972ac719c1ed2f6d7d4a5242e90.jpg";